import { consolidated } from "./consolidated";
import { financial } from "./financial";
import { withdraws } from "./withdraws";
import { devolution } from "./devolution";
import { adjustments } from "./adjustments";
import { accounts } from "./accounts";
import { flow } from "./flow";
import { anticipationDrawer } from "./anticipation-drawer";
import { withdrawRequestDrawer } from "./withdraw-request-drawer";
import { errorsValidations } from "./errors-validations";
import { transferForm } from "./transfer-form";
import { withdrawConfirmation } from "./withdraw-confirmation";
import { withdrawRequestDetails } from "#i18n/translations/es-MX/place/extract/withdraw-request-details";
import { locationNotes } from "./location-notes";
import { debitNotes } from "./debit-notes";

export const extract = {
	title: "Extracto",
	availableToWithdraw: "Disponible para retiro",
	owedToZig: "Saldo debido a ZIG",
	vendorOwned: "Debido a vendors",
	vendors: "Vendors",
	totalBalance: "Saldo total",
	totalBalanceAnticipation: "Saldo total para anticipación",
	valueAvailableToAnticipate: "Valor disponible para anticipación",
	availableToAnticipate: "Disponible para anticipación",
	anticipationD30ZeroFee: "Saldo de crédito anticipado disponible para retiro",
	paidToZig: "Valor a pagar a ZIG",
	availableMoreThanOneMonth: "Valor disponible en más de 30 días",
	paidToZigMoreThanOneMonth: "Valor a pagar a ZIG en más de 30 días",
	actionLabelBlocked: "Realizar retiro / Pagar boleta",
	bankslipAvailable: "Boleta disponible",
	dueDate_Abrev: "Venc",
	period: "Período",
	excelButton: "Exportar a Excel",
	tabs: {
		consolidated: "Consolidado",
		financial: "Extracto diario",
		withdraws: "Retiros, anticipaciones y boletas",
		devolution: "Recargas expiradas",
		adjustments: "Ajustes",
		accounts: "Cuentas guardadas",
		flow: "Extracto-Flujo de caja",
		locationNotes: "Notas de Alquiler",
		debitNotes: "Notas de débito",
		automaticWithdraw: "Retiro automático",
	},
	consolidated,
	financial,
	withdraws,
	devolution,
	adjustments,
	accounts,
	flow,
	anticipationDrawer,
	withdrawRequestDrawer,
	errorsValidations,
	transferForm,
	withdrawConfirmation,
	bankSlipForm: {
		warningBanner: {
			title: "Atención",
			description:
				"Solicitudes realizadas después de las 10h30 (horario de Brasilia) solo serán atendidas al día siguiente.",
		},
		tryAgain: "Intente nuevamente",
		request: "Solicitar",
		error: "No fue posible completar la solicitud.",
		success: "¡Pago de boleta solicitado con éxito!",
	},
	hooks: {
		value: "Valor de la anticipación",
		accountData: "Información de la cuenta",
		summary: "Revisión de los datos",
	},
	availableInTwoDays: "Saldo a ser liberado en los próximos 2 días",
	availableInMoreThanOneMonth: "Valor a ser liberado en más de 32 días",
	lastUpdated: "actualizado hace {{lastUpdated}}",
	withdrawRequestDetails,
	locationNotes,
	debitNotes,
	retainedBalance: "Saldo retenido",
	twentyPercentRetention: "Retención del 20% de los valores de los últimos 7 días",
	totalRetained: "Total retenido",
	relatedPartDataTooltip: "Datos especificados a partir del día 21/05/2024",
	automaticWithdraw: {
		type: "Tipo",
		vendorName: "Nombre del vendor",
		expectedAmount: "Valor del retiro programado",
		placeBalance: "Saldo del place",
		actualAmount: "Valor retirado",
		status: "Estado",
		vendor: "Vendor",
		place: "Place",
		error: "Error",
		success: "Éxito",
		partial: "Parcial",
	},
};
